<div *ngIf="triggerVisible" class="VideoTutorialTrigger">
  <div class="VideoTutorialTrigger-Button" (click)="showModal()">
    <one-icon class="p-0" name="videocam-outline"></one-icon>
  </div>
  <div class="VideoTutorialTrigger-Text">Tutorial</div>
</div>
